import { buildLocalizedPath } from '~/utils/buildLocalizedPath';
import { resolveSectionPath } from '~/utils/resolveSectionPath';

export function useCurrentSectionRootUrl() {
    const sectionConfig = useCurrentSectionConfig();
    const { country, lang } = useLanguage();
    const countryLanguages = useCountryLanguages();

    return computed(() => {
        const sectionPath = sectionConfig.value
            ? resolveSectionPath(sectionConfig.value, lang.value, countryLanguages)
            : null;

        return buildLocalizedPath(country.value, lang.value, sectionPath ?? '');
    });
}
